<template>
    <div ref="outerElementRef" class="settings-page__help">
        <help ref="helpRef" />
    </div>
</template>

<script lang="ts" setup>
    import { onMounted, onBeforeUnmount, ref, provide, type Ref } from "vue"
    import { useFocusedComponents } from '@/composables/useFocusedComponents';
    import { useRouter } from 'vue-router'

    definePageMeta({ 
        layout: 'default-no-header',
        middleware: ['set-page-indicator', 'fetch-help'],
    });

    const router = useRouter();
    const { setFocused, unsetFocused, outerElementRef } = useFocusedComponents('HelpPage');
    const { $navigator } = useNuxtApp();
    const isRegKeyListeners: Ref<boolean> = ref(false); 
    const helpRef = ref(null);
    const focusOnSwitch = (el: Ref): void => {
        (el.value as HTMLButtonElement).focus();
    }
    const registerKeyListeners = (): void => {
        if (!isRegKeyListeners.value) {
            $navigator.on("keypress:back", goToBack);
            isRegKeyListeners.value = true;
        }
    }
    const unregisterKeyListeners = (): void => {
        if (isRegKeyListeners.value) {
            $navigator.off("keypress:back", goToBack);
            isRegKeyListeners.value = false;
        }
    }
    const goToBack = (): void => {
        router.go(-1);
    }
    const setSelfFocused = (): void => {
        registerKeyListeners();
        setFocused();
    };
    const unsetSelfFocused = (): void => {
        unregisterKeyListeners();
        unsetFocused();
    };
    provide('focusOnSwitch', focusOnSwitch);
    onMounted(() => {
        setSelfFocused();
    })
    onBeforeUnmount(() => {
        unsetSelfFocused();
    })
</script>
